<template>
  <div class="row reverse-mobile justify-content-center">
    <UserMenu></UserMenu>

    <div class="col-12 col-md-9 center-content">
      <CommunityCard class="p-4">
        <div class="d-flex" style="padding-bottom: 60px;">
          <h3 class="text-inherit">My Media</h3>
          <router-link :to="{ name: 'media-upload' }" class="ml-auto">
            <button
              class="d-flex align-items-center btn btn-primary w-100 edit-button d"
            >
              <img src="../assets/add.svg" class="mr-2" />
              Create Media
            </button>
          </router-link>
        </div>

        <div v-if="isLoading">
          <PleaseWait :bgColour="'#FFFFFF'"></PleaseWait>
        </div>

        <div v-if="mediaCount <= 0 && !isLoading">
          <NoContributed></NoContributed>
        </div>

        <div v-else>
          <div class="placeholder row ml-3">
            <Media
              v-for="media in mediaObjects"
              :key="media.uuid_id"
              :media="media"
              :isMyMedia="true"
            ></Media>
          </div>

          <div class="row d-flex justify-content-center">
            <div
              v-if="mediaCount > 0"
              class="pagination-wrapper col-12 d-flex justify-content-end mt-3 mr-5"
            >
              <template>
                <paginate
                  v-model="page"
                  :page-count="pageCount"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="clickCallback"
                  prev-text="Prev"
                  next-text="Next"
                  container-class="pagination"
                  page-class="page-item"
                ></paginate>
              </template>
            </div>
          </div>
        </div>
      </CommunityCard>

      <Footer />
    </div>
  </div>
</template>

<script>
import mediaService from "../services/media.service";
import Paginate from "../components/Paginate";
import Media from "../components/Media";
import UserMenu from "../components/UserMenu";
import MediaObject from "../objects/MediaObject";
import NoContributed from "../components/NoContributed";
import PleaseWait from "../components/PleaseWait";
import CommunityCard from "../components/CommunityCard";
import Footer from "../components/Footer";

export default {
  name: "MyMediaItems",
  components: {
    Media,
    UserMenu,
    Paginate,
    NoContributed,
    PleaseWait,
    CommunityCard,
    Footer,
  },
  data: function() {
    return {
      isLoading: true,
      NUMBER_TO_GET: 6,
      pageCount: 0,
      page: 0,
      from: 0,
      to: 0,
      media: [],
      mediaTags: [],
      mediaCount: 0,
      pageNum: 0,
      mediaObjects: [],
      isActive: false,
    };
  },
  methods: {
    getMedia(startAt) {
      this.isLoading = true;
      this.isActive = true;
      mediaService.myMedia(startAt, this.NUMBER_TO_GET).then((data) => {
        this.mediaCount = data.total;
        this.mediaObjects = [];
        for (let media in data.media) {
          this.mediaObjects.push(new MediaObject(data.media[media]));
        }
        this.from = parseInt(data.from);
        this.to = parseInt(data.to);
        this.updatePageCount();
        this.isLoading = false;
      });

      this.isActive = false;
    },

    clickCallback: function(pageNum) {
      this.isActive = true;

      window.scrollTo(0, 0);
      this.page = pageNum;
      pageNum = pageNum - 1;
      this.mediaObjects = [];
      this.getMedia(this.NUMBER_TO_GET * pageNum);
    },

    updatePageCount() {
      this.pageCount = Math.ceil(this.mediaCount / this.NUMBER_TO_GET);
    },
  },

  beforeMount() {
    this.isLoading = true;
    this.getMedia();
  },
};
</script>

<style scoped>
.placeholder {
  z-index: 9;
  margin-bottom: 30px;
}

.lds-grid {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  position: absoloute;
  top: 0;
  left: 0;
  right: 0;
}
.lds-grid div {
  position: absolute;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #224b8c;
  animation: lds-grid 1.2s linear infinite;
}
.lds-grid div:nth-child(1) {
  top: 6px;
  left: 6px;
  animation-delay: 0s;
}
.lds-grid div:nth-child(2) {
  top: 6px;
  left: 26px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(3) {
  top: 6px;
  left: 45px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(4) {
  top: 26px;
  left: 6px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(5) {
  top: 26px;
  left: 26px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(6) {
  top: 26px;
  left: 45px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(7) {
  top: 45px;
  left: 6px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(8) {
  top: 45px;
  left: 26px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(9) {
  top: 45px;
  left: 45px;
  animation-delay: -1.6s;
}

@keyframes lds-grid {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Medium Devices, Desktops */
@media only screen and (max-width: 992px) {
  .pagination-wrapper {
    margin: 0px !important;
    padding: 0px !important;
    display: flex;
  }
  .pagination-wrapper ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>
